<div>
    <p class="card-subtitle me-2">
        <small>{{ label }}</small>
    </p>
    <p>{{ value ?? 'N/A' }}</p>
</div>
